// @generated by protobuf-ts 2.9.4 with parameter generate_dependencies,optimize_code_size
// @generated from protobuf file "core/v1/actions.proto" (package "core.v1", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
import { Date } from "./date";
import { AccountType } from "./accounts";
/**
 * @generated from protobuf message core.v1.MoveMoneyFromChequingToExpenseAction
 */
export interface MoveMoneyFromChequingToExpenseAction {
    /**
     * @generated from protobuf field: double amount = 1;
     */
    amount: number;
    /**
     * @generated from protobuf oneof: destination_expense
     */
    destinationExpense: {
        oneofKind: "destinationExpenseUuid";
        /**
         * @generated from protobuf field: string destination_expense_uuid = 2;
         */
        destinationExpenseUuid: string;
    } | {
        oneofKind: "destinationExpenseType";
        /**
         * @generated from protobuf field: core.v1.MoveMoneyFromChequingToExpenseAction.DestinationExpenseType destination_expense_type = 3;
         */
        destinationExpenseType: MoveMoneyFromChequingToExpenseAction_DestinationExpenseType;
    } | {
        oneofKind: undefined;
    };
    /**
     * Mortgage this expense belongs to (property tax / insurance). Used when the
     * expense itself has no durable uuid in the family DB.
     *
     * @generated from protobuf field: string associated_mortgage_uuid = 4;
     */
    associatedMortgageUuid: string;
}
/**
 * @generated from protobuf enum core.v1.MoveMoneyFromChequingToExpenseAction.DestinationExpenseType
 */
export enum MoveMoneyFromChequingToExpenseAction_DestinationExpenseType {
    /**
     * @generated from protobuf enum value: DESTINATION_EXPENSE_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: DESTINATION_EXPENSE_TYPE_MORTGAGE_INSURANCE = 1;
     */
    MORTGAGE_INSURANCE = 1,
    /**
     * @generated from protobuf enum value: DESTINATION_EXPENSE_TYPE_MORTGAGE_PROPERTY_TAX = 2;
     */
    MORTGAGE_PROPERTY_TAX = 2
}
/**
 * @generated from protobuf message core.v1.MoveMoneyFromChequingToDebtAction
 */
export interface MoveMoneyFromChequingToDebtAction {
    /**
     * @generated from protobuf field: double amount = 1;
     */
    amount: number;
    /**
     * @generated from protobuf field: string destination_debt_uuid = 2;
     */
    destinationDebtUuid: string;
}
/**
 * @generated from protobuf message core.v1.MoveMoneyFromChequingToAccountAction
 */
export interface MoveMoneyFromChequingToAccountAction {
    /**
     * @generated from protobuf field: double amount = 1;
     */
    amount: number;
    /**
     * @generated from protobuf field: string destination_account_uuid = 2;
     */
    destinationAccountUuid: string;
}
/**
 * @generated from protobuf message core.v1.MoveMoneyIntoChequingAction
 */
export interface MoveMoneyIntoChequingAction {
    /**
     * @generated from protobuf field: double amount = 1;
     */
    amount: number;
    /**
     * @generated from protobuf field: string source_account_uuid = 2;
     */
    sourceAccountUuid: string;
}
/**
 * @generated from protobuf message core.v1.ReamortizeDebtsIntoMortgageAction
 */
export interface ReamortizeDebtsIntoMortgageAction {
    /**
     * @generated from protobuf field: string mortgage_uuid = 1;
     */
    mortgageUuid: string;
    /**
     * @generated from protobuf field: repeated core.v1.ReamortizeDebtsIntoMortgageAction.DebtTransfer debt_transfers = 2;
     */
    debtTransfers: ReamortizeDebtsIntoMortgageAction_DebtTransfer[];
    /**
     * @generated from protobuf field: core.v1.ReamortizeDebtsIntoMortgageAction.MortgageTerms before = 3;
     */
    before?: ReamortizeDebtsIntoMortgageAction_MortgageTerms;
    /**
     * @generated from protobuf field: core.v1.ReamortizeDebtsIntoMortgageAction.MortgageTerms after = 4;
     */
    after?: ReamortizeDebtsIntoMortgageAction_MortgageTerms;
}
/**
 * @generated from protobuf message core.v1.ReamortizeDebtsIntoMortgageAction.DebtTransfer
 */
export interface ReamortizeDebtsIntoMortgageAction_DebtTransfer {
    /**
     * @generated from protobuf field: double amount = 1;
     */
    amount: number;
    /**
     * @generated from protobuf field: string debt_uuid = 2;
     */
    debtUuid: string;
}
/**
 * Mortgage terms either side of the refinance.
 *
 * @generated from protobuf message core.v1.ReamortizeDebtsIntoMortgageAction.MortgageTerms
 */
export interface ReamortizeDebtsIntoMortgageAction_MortgageTerms {
    /**
     * @generated from protobuf field: double balance = 1;
     */
    balance: number;
    /**
     * @generated from protobuf field: double interest_rate = 2;
     */
    interestRate: number; // annual, percent
    /**
     * @generated from protobuf field: int32 months_to_pay = 3;
     */
    monthsToPay: number;
    /**
     * @generated from protobuf field: double monthly_payment = 4;
     */
    monthlyPayment: number;
}
/**
 * @generated from protobuf message core.v1.CreateAccountAction
 */
export interface CreateAccountAction {
    /**
     * @generated from protobuf field: string person_uuid = 1;
     */
    personUuid: string;
    /**
     * @generated from protobuf field: core.v1.AccountType account_type = 2;
     */
    accountType: AccountType;
    /**
     * @generated from protobuf field: repeated core.v1.CreateAccountAction.MoveMoneyFromChequingToCreatedAccountAction move_money_from_chequing_to_created_account_actions = 3;
     */
    moveMoneyFromChequingToCreatedAccountActions: CreateAccountAction_MoveMoneyFromChequingToCreatedAccountAction[];
    /**
     * @generated from protobuf field: repeated core.v1.CreateAccountAction.MoveMoneyFromCreatedAccountToChequingAction move_money_from_created_account_to_chequing_actions = 4;
     */
    moveMoneyFromCreatedAccountToChequingActions: CreateAccountAction_MoveMoneyFromCreatedAccountToChequingAction[];
    /**
     * @generated from protobuf field: string created_account_uuid = 5;
     */
    createdAccountUuid: string;
}
/**
 * @generated from protobuf message core.v1.CreateAccountAction.MoveMoneyFromChequingToCreatedAccountAction
 */
export interface CreateAccountAction_MoveMoneyFromChequingToCreatedAccountAction {
    /**
     * @generated from protobuf field: double amount = 1;
     */
    amount: number;
    /**
     * @generated from protobuf field: core.v1.Date date = 2;
     */
    date?: Date;
    /**
     * @generated from protobuf field: int32 id = 3;
     */
    id: number;
}
/**
 * @generated from protobuf message core.v1.CreateAccountAction.MoveMoneyFromCreatedAccountToChequingAction
 */
export interface CreateAccountAction_MoveMoneyFromCreatedAccountToChequingAction {
    /**
     * @generated from protobuf field: double amount = 1;
     */
    amount: number;
    /**
     * @generated from protobuf field: core.v1.Date date = 2;
     */
    date?: Date;
    /**
     * @generated from protobuf field: int32 id = 3;
     */
    id: number;
}
/**
 * @generated from protobuf message core.v1.TransferFhsaToRrspAction
 */
export interface TransferFhsaToRrspAction {
    /**
     * @generated from protobuf field: double amount = 1;
     */
    amount: number;
    /**
     * @generated from protobuf field: string source_fhsa_uuid = 2;
     */
    sourceFhsaUuid: string;
    /**
     * @generated from protobuf field: string destination_rrsp_uuid = 3;
     */
    destinationRrspUuid: string;
    /**
     * @generated from protobuf field: core.v1.TransferFhsaToRrspAction.Reason reason = 4;
     */
    reason: TransferFhsaToRrspAction_Reason;
}
/**
 * Why the plan moves the FHSA (unset: a transfer the household reported).
 *
 * @generated from protobuf enum core.v1.TransferFhsaToRrspAction.Reason
 */
export enum TransferFhsaToRrspAction_Reason {
    /**
     * @generated from protobuf enum value: REASON_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * The holder isn't a first-time home buyer, and the household hasn't confirmed the move
     * (FHSAAccount.transfer_to_rrsp_confirmed): the data may be wrong, so the app warns before it's done.
     *
     * @generated from protobuf enum value: REASON_NOT_FIRST_TIME_BUYER_UNCONFIRMED = 1;
     */
    NOT_FIRST_TIME_BUYER_UNCONFIRMED = 1,
    /**
     * The holder isn't a first-time home buyer and the household confirmed the move.
     *
     * @generated from protobuf enum value: REASON_NOT_FIRST_TIME_BUYER_CONFIRMED = 2;
     */
    NOT_FIRST_TIME_BUYER_CONFIRMED = 2,
    /**
     * A qualifying withdrawal (the home purchase) was made: what's left moves before the FHSA closes.
     *
     * @generated from protobuf enum value: REASON_HOME_PURCHASED = 3;
     */
    HOME_PURCHASED = 3,
    /**
     * The holder turns 71 within about six months (or has): the FHSA must close.
     *
     * @generated from protobuf enum value: REASON_AGE_71 = 4;
     */
    AGE_71 = 4,
    /**
     * The household has no homebuying priority (none entered, or every one is done), so the FHSA moves
     * to the RRSP, where it stays tax-sheltered.
     *
     * @generated from protobuf enum value: REASON_NO_HOMEBUYING_GOAL = 5;
     */
    NO_HOMEBUYING_GOAL = 5,
    /**
     * Every homebuying priority ends today without a qualifying withdrawal.
     *
     * @generated from protobuf enum value: REASON_HOMEBUYING_GOAL_DUE = 6;
     */
    HOMEBUYING_GOAL_DUE = 6
}
/**
 * @generated from protobuf message core.v1.CreateHouseAndMortgageAction
 */
export interface CreateHouseAndMortgageAction {
    /**
     * @generated from protobuf field: string priority_uuid = 1;
     */
    priorityUuid: string;
    /**
     * @generated from protobuf field: double house_price = 2;
     */
    housePrice: number;
    /**
     * @generated from protobuf field: double down_payment = 3;
     */
    downPayment: number;
}
/**
 * @generated from protobuf message core.v1.ConvertRrspToRrifAction
 */
export interface ConvertRrspToRrifAction {
    /**
     * @generated from protobuf field: double amount = 1;
     */
    amount: number;
    /**
     * @generated from protobuf field: string rrsp_uuid = 2;
     */
    rrspUuid: string;
}
/**
 * @generated from protobuf message core.v1.PayPriorityAction
 */
export interface PayPriorityAction {
    /**
     * @generated from protobuf field: string priority_uuid = 1;
     */
    priorityUuid: string;
    /**
     * @generated from protobuf field: double amount = 2;
     */
    amount: number;
    /**
     * @generated from protobuf field: double required_funding = 3;
     */
    requiredFunding: number;
}
/**
 * @generated from protobuf message core.v1.SetGroupRrspContributionAction
 */
export interface SetGroupRrspContributionAction {
    /**
     * @generated from protobuf field: string job_uuid = 1;
     */
    jobUuid: string;
    /**
     * @generated from protobuf field: string group_rrsp_uuid = 2;
     */
    groupRrspUuid: string;
    /**
     * @generated from protobuf field: double employee_contribution_rate = 3;
     */
    employeeContributionRate: number; // e.g. 0.05 = 5% of gross pay
    /**
     * @generated from protobuf field: double previous_employee_contribution_rate = 4;
     */
    previousEmployeeContributionRate: number; // OUTPUT ONLY: the rate this replaces
}
/**
 * @generated from protobuf message core.v1.Action
 */
export interface Action {
    /**
     * @generated from protobuf field: core.v1.Date date = 1;
     */
    date?: Date;
    /**
     * @generated from protobuf oneof: action_type
     */
    actionType: {
        oneofKind: "moveMoneyFromChequingToAccountAction";
        /**
         * @generated from protobuf field: core.v1.MoveMoneyFromChequingToAccountAction move_money_from_chequing_to_account_action = 2;
         */
        moveMoneyFromChequingToAccountAction: MoveMoneyFromChequingToAccountAction;
    } | {
        oneofKind: "moveMoneyFromChequingToDebtAction";
        /**
         * @generated from protobuf field: core.v1.MoveMoneyFromChequingToDebtAction move_money_from_chequing_to_debt_action = 3;
         */
        moveMoneyFromChequingToDebtAction: MoveMoneyFromChequingToDebtAction;
    } | {
        oneofKind: "moveMoneyFromChequingToExpenseAction";
        /**
         * @generated from protobuf field: core.v1.MoveMoneyFromChequingToExpenseAction move_money_from_chequing_to_expense_action = 4;
         */
        moveMoneyFromChequingToExpenseAction: MoveMoneyFromChequingToExpenseAction;
    } | {
        oneofKind: "moveMoneyIntoChequingAction";
        /**
         * @generated from protobuf field: core.v1.MoveMoneyIntoChequingAction move_money_into_chequing_action = 5;
         */
        moveMoneyIntoChequingAction: MoveMoneyIntoChequingAction;
    } | {
        oneofKind: "reamortizeDebtsIntoMortgageAction";
        /**
         * @generated from protobuf field: core.v1.ReamortizeDebtsIntoMortgageAction reamortize_debts_into_mortgage_action = 6;
         */
        reamortizeDebtsIntoMortgageAction: ReamortizeDebtsIntoMortgageAction;
    } | {
        oneofKind: "createAccountAction";
        /**
         * @generated from protobuf field: core.v1.CreateAccountAction create_account_action = 7;
         */
        createAccountAction: CreateAccountAction; // OUTPUT ONLY
    } | {
        oneofKind: "transferFhsaToRrspAction";
        /**
         * @generated from protobuf field: core.v1.TransferFhsaToRrspAction transfer_fhsa_to_rrsp_action = 8;
         */
        transferFhsaToRrspAction: TransferFhsaToRrspAction;
    } | {
        oneofKind: "createHouseAndMortgageAction";
        /**
         * @generated from protobuf field: core.v1.CreateHouseAndMortgageAction create_house_and_mortgage_action = 9;
         */
        createHouseAndMortgageAction: CreateHouseAndMortgageAction;
    } | {
        oneofKind: "convertRrspToRrifAction";
        /**
         * @generated from protobuf field: core.v1.ConvertRrspToRrifAction convert_rrsp_to_rrif_action = 10;
         */
        convertRrspToRrifAction: ConvertRrspToRrifAction;
    } | {
        oneofKind: "payPriorityAction";
        /**
         * @generated from protobuf field: core.v1.PayPriorityAction pay_priority_action = 11;
         */
        payPriorityAction: PayPriorityAction;
    } | {
        oneofKind: "setGroupRrspContributionAction";
        /**
         * @generated from protobuf field: core.v1.SetGroupRrspContributionAction set_group_rrsp_contribution_action = 16;
         */
        setGroupRrspContributionAction: SetGroupRrspContributionAction; // OUTPUT ONLY
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: int32 id = 12;
     */
    id: number;
    /**
     * A bill or minimum payment the household must make, vs a recommendation it may choose to follow.
     *
     * @generated from protobuf field: bool mandatory = 13;
     */
    mandatory: boolean;
    /**
     * @generated from protobuf field: core.v1.ActionCategory category = 14;
     */
    category: ActionCategory;
    /**
     * @generated from protobuf field: string member_uuid = 15;
     */
    memberUuid: string; // the person whose money it is, if any
}
/**
 * @generated from protobuf message core.v1.CompletedAction
 */
export interface CompletedAction {
    /**
     * @generated from protobuf field: core.v1.Action abi_recommended = 1;
     */
    abiRecommended?: Action;
    /**
     * @generated from protobuf field: core.v1.Action user_submitted = 2;
     */
    userSubmitted?: Action;
}
/**
 * What an action's money is for, so views group it without guessing from names.
 *
 * @generated from protobuf enum core.v1.ActionCategory
 */
export enum ActionCategory {
    /**
     * @generated from protobuf enum value: ACTION_CATEGORY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * essential household expenses
     *
     * @generated from protobuf enum value: ACTION_CATEGORY_ESSENTIAL = 1;
     */
    ESSENTIAL = 1,
    /**
     * non-essential household expenses
     *
     * @generated from protobuf enum value: ACTION_CATEGORY_LIFESTYLE = 2;
     */
    LIFESTYLE = 2,
    /**
     * rent, property tax, home insurance
     *
     * @generated from protobuf enum value: ACTION_CATEGORY_HOUSING = 3;
     */
    HOUSING = 3,
    /**
     * @generated from protobuf enum value: ACTION_CATEGORY_DEBT_MINIMUM = 4;
     */
    DEBT_MINIMUM = 4,
    /**
     * payments above the minimum
     *
     * @generated from protobuf enum value: ACTION_CATEGORY_DEBT_EXTRA = 5;
     */
    DEBT_EXTRA = 5,
    /**
     * contributions to accounts
     *
     * @generated from protobuf enum value: ACTION_CATEGORY_SAVING = 6;
     */
    SAVING = 6,
    /**
     * money moved back into chequing
     *
     * @generated from protobuf enum value: ACTION_CATEGORY_WITHDRAWAL = 7;
     */
    WITHDRAWAL = 7,
    /**
     * paying toward a priority
     *
     * @generated from protobuf enum value: ACTION_CATEGORY_PRIORITY = 8;
     */
    PRIORITY = 8,
    /**
     * @generated from protobuf enum value: ACTION_CATEGORY_OTHER = 9;
     */
    OTHER = 9
}
// @generated message type with reflection information, may provide speed optimized methods
class MoveMoneyFromChequingToExpenseAction$Type extends MessageType<MoveMoneyFromChequingToExpenseAction> {
    constructor() {
        super("core.v1.MoveMoneyFromChequingToExpenseAction", [
            { no: 1, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "destination_expense_uuid", kind: "scalar", oneof: "destinationExpense", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "destination_expense_type", kind: "enum", oneof: "destinationExpense", T: () => ["core.v1.MoveMoneyFromChequingToExpenseAction.DestinationExpenseType", MoveMoneyFromChequingToExpenseAction_DestinationExpenseType, "DESTINATION_EXPENSE_TYPE_"] },
            { no: 4, name: "associated_mortgage_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.MoveMoneyFromChequingToExpenseAction
 */
export const MoveMoneyFromChequingToExpenseAction = new MoveMoneyFromChequingToExpenseAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MoveMoneyFromChequingToDebtAction$Type extends MessageType<MoveMoneyFromChequingToDebtAction> {
    constructor() {
        super("core.v1.MoveMoneyFromChequingToDebtAction", [
            { no: 1, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "destination_debt_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.MoveMoneyFromChequingToDebtAction
 */
export const MoveMoneyFromChequingToDebtAction = new MoveMoneyFromChequingToDebtAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MoveMoneyFromChequingToAccountAction$Type extends MessageType<MoveMoneyFromChequingToAccountAction> {
    constructor() {
        super("core.v1.MoveMoneyFromChequingToAccountAction", [
            { no: 1, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "destination_account_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.MoveMoneyFromChequingToAccountAction
 */
export const MoveMoneyFromChequingToAccountAction = new MoveMoneyFromChequingToAccountAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MoveMoneyIntoChequingAction$Type extends MessageType<MoveMoneyIntoChequingAction> {
    constructor() {
        super("core.v1.MoveMoneyIntoChequingAction", [
            { no: 1, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "source_account_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.MoveMoneyIntoChequingAction
 */
export const MoveMoneyIntoChequingAction = new MoveMoneyIntoChequingAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReamortizeDebtsIntoMortgageAction$Type extends MessageType<ReamortizeDebtsIntoMortgageAction> {
    constructor() {
        super("core.v1.ReamortizeDebtsIntoMortgageAction", [
            { no: 1, name: "mortgage_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "debt_transfers", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => ReamortizeDebtsIntoMortgageAction_DebtTransfer },
            { no: 3, name: "before", kind: "message", T: () => ReamortizeDebtsIntoMortgageAction_MortgageTerms },
            { no: 4, name: "after", kind: "message", T: () => ReamortizeDebtsIntoMortgageAction_MortgageTerms }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.ReamortizeDebtsIntoMortgageAction
 */
export const ReamortizeDebtsIntoMortgageAction = new ReamortizeDebtsIntoMortgageAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReamortizeDebtsIntoMortgageAction_DebtTransfer$Type extends MessageType<ReamortizeDebtsIntoMortgageAction_DebtTransfer> {
    constructor() {
        super("core.v1.ReamortizeDebtsIntoMortgageAction.DebtTransfer", [
            { no: 1, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "debt_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.ReamortizeDebtsIntoMortgageAction.DebtTransfer
 */
export const ReamortizeDebtsIntoMortgageAction_DebtTransfer = new ReamortizeDebtsIntoMortgageAction_DebtTransfer$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReamortizeDebtsIntoMortgageAction_MortgageTerms$Type extends MessageType<ReamortizeDebtsIntoMortgageAction_MortgageTerms> {
    constructor() {
        super("core.v1.ReamortizeDebtsIntoMortgageAction.MortgageTerms", [
            { no: 1, name: "balance", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "interest_rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "months_to_pay", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "monthly_payment", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.ReamortizeDebtsIntoMortgageAction.MortgageTerms
 */
export const ReamortizeDebtsIntoMortgageAction_MortgageTerms = new ReamortizeDebtsIntoMortgageAction_MortgageTerms$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAccountAction$Type extends MessageType<CreateAccountAction> {
    constructor() {
        super("core.v1.CreateAccountAction", [
            { no: 1, name: "person_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "account_type", kind: "enum", T: () => ["core.v1.AccountType", AccountType, "ACCOUNT_TYPE_"] },
            { no: 3, name: "move_money_from_chequing_to_created_account_actions", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => CreateAccountAction_MoveMoneyFromChequingToCreatedAccountAction },
            { no: 4, name: "move_money_from_created_account_to_chequing_actions", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => CreateAccountAction_MoveMoneyFromCreatedAccountToChequingAction },
            { no: 5, name: "created_account_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.CreateAccountAction
 */
export const CreateAccountAction = new CreateAccountAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAccountAction_MoveMoneyFromChequingToCreatedAccountAction$Type extends MessageType<CreateAccountAction_MoveMoneyFromChequingToCreatedAccountAction> {
    constructor() {
        super("core.v1.CreateAccountAction.MoveMoneyFromChequingToCreatedAccountAction", [
            { no: 1, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "date", kind: "message", T: () => Date },
            { no: 3, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.CreateAccountAction.MoveMoneyFromChequingToCreatedAccountAction
 */
export const CreateAccountAction_MoveMoneyFromChequingToCreatedAccountAction = new CreateAccountAction_MoveMoneyFromChequingToCreatedAccountAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAccountAction_MoveMoneyFromCreatedAccountToChequingAction$Type extends MessageType<CreateAccountAction_MoveMoneyFromCreatedAccountToChequingAction> {
    constructor() {
        super("core.v1.CreateAccountAction.MoveMoneyFromCreatedAccountToChequingAction", [
            { no: 1, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "date", kind: "message", T: () => Date },
            { no: 3, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.CreateAccountAction.MoveMoneyFromCreatedAccountToChequingAction
 */
export const CreateAccountAction_MoveMoneyFromCreatedAccountToChequingAction = new CreateAccountAction_MoveMoneyFromCreatedAccountToChequingAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TransferFhsaToRrspAction$Type extends MessageType<TransferFhsaToRrspAction> {
    constructor() {
        super("core.v1.TransferFhsaToRrspAction", [
            { no: 1, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "source_fhsa_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "destination_rrsp_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "reason", kind: "enum", T: () => ["core.v1.TransferFhsaToRrspAction.Reason", TransferFhsaToRrspAction_Reason, "REASON_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.TransferFhsaToRrspAction
 */
export const TransferFhsaToRrspAction = new TransferFhsaToRrspAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateHouseAndMortgageAction$Type extends MessageType<CreateHouseAndMortgageAction> {
    constructor() {
        super("core.v1.CreateHouseAndMortgageAction", [
            { no: 1, name: "priority_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "house_price", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "down_payment", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.CreateHouseAndMortgageAction
 */
export const CreateHouseAndMortgageAction = new CreateHouseAndMortgageAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConvertRrspToRrifAction$Type extends MessageType<ConvertRrspToRrifAction> {
    constructor() {
        super("core.v1.ConvertRrspToRrifAction", [
            { no: 1, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "rrsp_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.ConvertRrspToRrifAction
 */
export const ConvertRrspToRrifAction = new ConvertRrspToRrifAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PayPriorityAction$Type extends MessageType<PayPriorityAction> {
    constructor() {
        super("core.v1.PayPriorityAction", [
            { no: 1, name: "priority_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "required_funding", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.PayPriorityAction
 */
export const PayPriorityAction = new PayPriorityAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetGroupRrspContributionAction$Type extends MessageType<SetGroupRrspContributionAction> {
    constructor() {
        super("core.v1.SetGroupRrspContributionAction", [
            { no: 1, name: "job_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "group_rrsp_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "employee_contribution_rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "previous_employee_contribution_rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.SetGroupRrspContributionAction
 */
export const SetGroupRrspContributionAction = new SetGroupRrspContributionAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Action$Type extends MessageType<Action> {
    constructor() {
        super("core.v1.Action", [
            { no: 1, name: "date", kind: "message", T: () => Date },
            { no: 2, name: "move_money_from_chequing_to_account_action", kind: "message", oneof: "actionType", T: () => MoveMoneyFromChequingToAccountAction },
            { no: 3, name: "move_money_from_chequing_to_debt_action", kind: "message", oneof: "actionType", T: () => MoveMoneyFromChequingToDebtAction },
            { no: 4, name: "move_money_from_chequing_to_expense_action", kind: "message", oneof: "actionType", T: () => MoveMoneyFromChequingToExpenseAction },
            { no: 5, name: "move_money_into_chequing_action", kind: "message", oneof: "actionType", T: () => MoveMoneyIntoChequingAction },
            { no: 6, name: "reamortize_debts_into_mortgage_action", kind: "message", oneof: "actionType", T: () => ReamortizeDebtsIntoMortgageAction },
            { no: 7, name: "create_account_action", kind: "message", oneof: "actionType", T: () => CreateAccountAction },
            { no: 8, name: "transfer_fhsa_to_rrsp_action", kind: "message", oneof: "actionType", T: () => TransferFhsaToRrspAction },
            { no: 9, name: "create_house_and_mortgage_action", kind: "message", oneof: "actionType", T: () => CreateHouseAndMortgageAction },
            { no: 10, name: "convert_rrsp_to_rrif_action", kind: "message", oneof: "actionType", T: () => ConvertRrspToRrifAction },
            { no: 11, name: "pay_priority_action", kind: "message", oneof: "actionType", T: () => PayPriorityAction },
            { no: 16, name: "set_group_rrsp_contribution_action", kind: "message", oneof: "actionType", T: () => SetGroupRrspContributionAction },
            { no: 12, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "mandatory", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "category", kind: "enum", T: () => ["core.v1.ActionCategory", ActionCategory, "ACTION_CATEGORY_"] },
            { no: 15, name: "member_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.Action
 */
export const Action = new Action$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CompletedAction$Type extends MessageType<CompletedAction> {
    constructor() {
        super("core.v1.CompletedAction", [
            { no: 1, name: "abi_recommended", kind: "message", T: () => Action },
            { no: 2, name: "user_submitted", kind: "message", T: () => Action }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.CompletedAction
 */
export const CompletedAction = new CompletedAction$Type();
